import { ThemeOptions } from '@mui/material/styles';

export const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#CAC9C9',
      light: '#ecebeb',
      dark: '#828181',
    },
    secondary: {
      main: '#d64545',
      light: '#e54d48',
      dark: '#c43d3e',
    },
    text: {
      primary: '#E2E2E2',
      secondary: '#efefef',
      disabled: '#f5f5f5',
    },
    background: {
      default: '#313131',
      paper: '#847464',
    },
    error: {
      main: '#f96f6f',
    },
    warning: {
      main: '#ea8b3c',
    },
    info: {
      main: '#0d80bd',
    },
    success: {
      main: '#3eb545',
    },
    divider: '#f3f2f2',
  },
  typography: {
    fontFamily: 'Playfair Display',
    h1: {
      fontFamily: 'Playfair Display',
      fontSize: '5rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '3rem', // Adjust font size for small screens
      },
    },
    h2: {
      fontFamily: 'Playfair Display',
      fontSize: '4rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '2.5rem', // Adjust font size for small screens
      },
    },
    h3: {
      fontFamily: 'Playfair Display',
      fontSize: '3rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '2rem', // Adjust font size for small screens
      },
    },
    h4: {
      fontFamily: 'Playfair Display',
      fontSize: '2.5rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '1.8rem', // Adjust font size for small screens
      },
    },
    h5: {
      fontFamily: 'Playfair Display',
      fontSize: '2rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '1.5rem', // Adjust font size for small screens
      },
    },
    h6: {
      fontFamily: 'Playfair Display',
      fontSize: '1rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '.9rem', // Adjust font size for small screens
      },
    },
    body1: {
      fontFamily: 'Playfair Display',
    },
    body2: {
      fontFamily: 'Playfair Display',
    },
    
    button: {
      fontFamily: 'Playfair Display',
      fontWeight: 700,
      fontSize: '0.8rem',
      [`@media (max-width: 600px)`]: {
        fontSize: '0.8rem', // Adjust font size for small screens
      },
    },
  },
  components: {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 46,
          height: 27,
          padding: 0,
          margin: 8,
        },
        switchBase: {
          padding: 1,
          '&$checked, &$colorPrimary$checked, &$colorSecondary$checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + $track': {
              opacity: 1,
              border: 'none',
            },
          },
        },
        thumb: {
          width: 24,
          height: 24,
        },
        track: {
          borderRadius: 13,
          border: '1px solid #bdbdbd',
          backgroundColor: '#fafafa',
          opacity: 1,
          transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        },
      },
    },
  },
};
